module.exports = __webpack_public_path__ + "img/cegep_beauce_appalache.0227be20.png";